import React from "react";
import SideBarItem from "./SideBarItem";
import "./styles.scss";
import { type Step } from "../../../components/Stepper/Stepper";
import { useLocation } from "react-router-dom";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";

interface DashboardSideBarProps {
  onClickItem: (step: Step) => void;
  steps: Step[];
}

export default function DashboardSideBar(props: DashboardSideBarProps) {
  const location = useLocation();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const isSelected = (item: Step) => {
    if (!item.pathName) {
      return false;
    }
    return location.pathname.includes(item.pathName);
  };

  return (
    <div className="gap-lg d-none d-lg-flex p-4 p-sm-5 dashboard-side-bar">
      {props.steps.map((item) => {
        return (
          <SideBarItem
            onClickItem={() => {
              props.onClickItem(item);
            }}
            icon={item.svg}
            text={item.name}
            isSelected={isSelected(item)}
            key={item.index}
          />
        );
      })}
    </div>
  );
}
